import XHeader from 'vux/src/components/x-header/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

export default {
name: 'paySuccess',
components: {
XHeader,
CheckIcon,
Group,
XButton
},
data () {
return {
orders: {
orderInfo: {
totalAmt: 0
}
},
}
},
methods: {

getGoods () {
this.$request.post('/pay/getOrderInfo',{
orderCode: this.$route.query.orderId
}).then(data => {
if(data.code == 0){
this.orders = data.obj
}
}).catch(e => {
})
},
order () {
this.$router.push({
path: '/myOrder',
query: {
orderStatus: '9999'
}
})
}
},
created () {
this.getGoods()

},
mounted() {

},
}



// WEBPACK FOOTER //
// ./src/views/paySuccess/script.js